import { useCompanySummary } from '@/pages/CompanyReport/components/OverviewSection/hooks/useCompanySummary/useCompanySummary';
import { getPath } from '@/router/utils';
import { ROUTE_STOCK_PAGE } from '@/constants/routes';

/**
 * Hook to generate stock URL using company summary data.
 * @param canonicalUrl - The canonical URL of the company
 * @returns { stockUrl } - The generated stock URL or null if data is not available
 */
export const useStockUrl = (canonicalUrl: undefined | string) => {
  const { tickerSymbol, exchangeSymbol } = useCompanySummary({ canonicalUrl });

  const stockUrl =
    exchangeSymbol && tickerSymbol
      ? getPath({
          type: ROUTE_STOCK_PAGE,
          payload: {
            exchange: exchangeSymbol.toLowerCase(),
            ticker: tickerSymbol.toLowerCase(),
          },
        })
      : null;

  return { stockUrl };
};
